// @ts-nocheck
/* eslint-disable */
export const arrowSideLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><g fill="currentColor" clip-path="url(#a)"><path d="M1.54 0v4.22L3.32 6 1.54 7.78V12l6-6zM9 12h2V0H9z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 12h12V0H0z"/></clipPath></defs></svg>`,
    name: 'arrow-side-left' as const
};